import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UiTranslateModule } from '@fcom/ui-translate';

import { HeadingTagComponent } from './heading-tag/heading-tag.component';
import { PlainHeaderAreaComponent } from './plain-header-area/plain-header-area.component';
import { ButtonModule } from '../../components/buttons';

@NgModule({
  declarations: [PlainHeaderAreaComponent],
  imports: [CommonModule, UiTranslateModule, ButtonModule, HeadingTagComponent],
  exports: [HeadingTagComponent, PlainHeaderAreaComponent],
  providers: [],
})
export class HeadersModule {}
